var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSegmentSize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.38398,
    cy: 9.70275,
    rx: 6.91816,
    ry: 6.79406,
    fill: "#E1E1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5529 9.82798C15.5529 8.88611 15.3674 7.95347 15.007 7.08329C14.6465 6.21312 14.1182 5.42246 13.4522 4.75646C12.7862 4.09045 11.9956 3.56215 11.1254 3.20171C10.2552 2.84128 9.32259 2.65576 8.38072 2.65576L8.38072 9.82798L15.5529 9.82798Z",
    fill: "#86BB00",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5529 9.82798C15.5529 11.7302 14.7973 13.5545 13.4522 14.8995L8.38072 9.82798L15.5529 9.82798Z",
    fill: "#BBBBBB",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4522 14.8995C12.1072 16.2446 10.2829 17.0002 8.38072 17.0002L8.38072 9.82798L13.4522 14.8995Z",
    fill: "#BBBBBB",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38072 17.0002C6.47853 17.0002 4.65424 16.2446 3.30919 14.8995L8.38072 9.82798L8.38072 17.0002Z",
    fill: "#BBBBBB",
    stroke: "white",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30919 14.8995C2.64319 14.2335 2.11489 13.4428 1.75445 12.5727C1.39401 11.7025 1.2085 10.7699 1.2085 9.82798L8.38072 9.82798L3.30919 14.8995Z",
    fill: "#BBBBBB",
    stroke: "white",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2085 9.82798C1.2085 7.92579 1.96414 6.10151 3.30919 4.75646L8.38072 9.82798L1.2085 9.82798Z",
    fill: "#BBBBBB",
    stroke: "white",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30919 4.75646C3.97519 4.09045 4.76585 3.56215 5.63603 3.20171C6.5062 2.84128 7.43885 2.65576 8.38072 2.65576L8.38072 9.82798L3.30919 4.75646Z",
    fill: "#BBBBBB",
    stroke: "white",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37119 13.7534C10.6378 13.7534 12.4753 11.9342 12.4753 9.69016C12.4753 7.44611 10.6378 5.62695 8.37119 5.62695C6.10456 5.62695 4.26709 7.44611 4.26709 9.69016C4.26709 11.9342 6.10456 13.7534 8.37119 13.7534Z",
    fill: "#F6F7F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.318 0.999811L10.7784 1.6657L11.4442 2.20298",
    stroke: "#123051",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4832 6.25021L16.0447 6.89772L16.69 6.33591",
    stroke: "#123051",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.072 6.36937C16.072 5.09561 15.571 3.93885 14.7553 3.08541C13.8898 2.17981 12.67 1.61572 11.3184 1.61572",
    stroke: "#123051",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentSize);
export default __webpack_public_path__ + "static/media/segmentSize.15625a02452aeca6b38152694853a3e0.svg";
export { ForwardRef as ReactComponent };